export default "__VITE_ASSET__9811e7f9__"